import React from 'react';
import { Link } from 'react-router-dom';
import { shopCategories } from '../shopData';
import { ArrowRight } from 'lucide-react';
import Ornament from '../components/Ornament';
import useDocumentTitle from '../hooks/useDocumentTitle';

const ShopPage = () => {
  useDocumentTitle(
    'Our Collection | Shri Kothari Jewellers',
    "Explore Shri Kothari Jewellers' curated collection of premium silver jewellery, sacred idols, puja accessories, utensils and gifts in Indore."
  );

  return (
    <div className="lux-section" style={{ paddingTop: '7rem', minHeight: '100vh' }}>
      <div className="lux-container">
        {/* Header */}
        <div className="lux-header">
          <div className="lux-eyebrow">Shop · Since 1987</div>
          <h1 className="lux-title">
            Our Collection
          </h1>
          <Ornament />
          <p className="lux-subtitle">
            Explore our curated selection of premium silver jewellery, sacred idols,
            puja accessories, utensils, and exquisite gifts.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="lux-shop-grid">
          {shopCategories.map((category) => (
            <Link
              key={category.id}
              to={`/shop/${category.slug}`}
              className="lux-shop-card"
              data-testid={`shop-card-${category.slug}`}
            >
              <div className="lux-shop-image-wrap">
                <img
                  src={category.image}
                  alt={category.name}
                  className="lux-shop-image"
                />
                <div className="lux-shop-overlay"></div>
              </div>
              <div className="lux-shop-content">
                <h3 className="lux-shop-title">{category.name}</h3>
                <p className="lux-shop-desc">{category.description}</p>
                <span className="lux-shop-cta">
                  Explore <ArrowRight size={16} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopPage;
